import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { appendElement7nmjunfw9r4 as appendElement } from '../text/Appendable.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
} from '../ranges/_Ranges.mjs';
import {
  addAll1k27qatfgp3k5 as addAll,
  convertToListIfNotCollection2y7m25iq802o0 as convertToListIfNotCollection,
  retainAll12dge99qrkea2 as retainAll,
  addAll3rgorw6ix9mgp as addAll_0,
} from './MutableCollections.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
} from './Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../js/typeCheckUtils.mjs';
import {
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  emptyList1g2z5xcrvp2zy as emptyList,
  optimizeReadOnlyList2kolyxeo5m6k3 as optimizeReadOnlyList,
} from './CollectionsKt.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  setOf1u3mizs95ngxo as setOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  copyToArray2j022khrow2yi as copyToArray,
  sortWith4fnm6b3vw03s as sortWith,
  sort15ai02l4kxbfa as sort,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from './collectionJs.mjs';
import {
  IndexingIterable2a6g9uso7i6wu as IndexingIterable,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
} from './Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../Tuples.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import {
  emptySetcxexqki71qfa as emptySet,
  optimizeReadOnlySetbkgqv9johc5 as optimizeReadOnlySet,
} from './Sets.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from './LinkedHashSet.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from './HashSet.mjs';
import { booleanArray2jdug9b51huk7 as booleanArray } from '../js/arrays.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import { reversenv3adafjrtzo as reverse } from './_CollectionsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  sortWith23lt7r6b8svqd as sortWith_0,
  asList2ho2pewtsfvv as asList,
  sort1opyk0uibi7i3 as sort_0,
} from './_ArraysJs.mjs';
import { reverseOrder2s0vaorjckcnt as reverseOrder } from '../comparisons/Comparisons.mjs';
import {
  checkWindowSizeStepcg5bise2nnst as checkWindowSizeStep,
  windowedIterator1l52d653czu3r as windowedIterator,
} from './SlidingWindow.mjs';
import { Sequence1quqbxersk0bb as Sequence } from '../sequences/Sequence.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  return joinTo(_this__u8e3s4, StringBuilder().d1(), separator, prefix, postfix, limit, truncated, transform).toString();
}
function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  buffer.e1(prefix);
  var count = 0;
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  $l$loop: while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    count = count + 1 | 0;
    if (count > 1) {
      buffer.e1(separator);
    }
    if (limit < 0 || count <= limit) {
      appendElement(buffer, element, transform);
    } else
      break $l$loop;
  }
  if (limit >= 0 && count > limit) {
    buffer.e1(truncated);
  }
  buffer.e1(postfix);
  return buffer;
}
function lastOrNull(_this__u8e3s4) {
  return _this__u8e3s4.i1() ? null : _this__u8e3s4.q1(_this__u8e3s4.p1() - 1 | 0);
}
function plus(_this__u8e3s4, element) {
  var result = ArrayList().u(_this__u8e3s4.p1() + 1 | 0);
  result.r1(_this__u8e3s4);
  result.v(element);
  return result;
}
function dropLast(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().a1(toString(message));
  }
  return take(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.p1() - n | 0, 0));
}
function asSequence(_this__u8e3s4) {
  // Inline function 'kotlin.sequences.Sequence' call
  return new (asSequence$$inlined$Sequence$1())(_this__u8e3s4);
}
function getOrNull(_this__u8e3s4, index) {
  return (0 <= index ? index < _this__u8e3s4.p1() : false) ? _this__u8e3s4.q1(index) : null;
}
function firstOrNull(_this__u8e3s4) {
  return _this__u8e3s4.i1() ? null : _this__u8e3s4.q1(0);
}
function singleOrNull(_this__u8e3s4) {
  return _this__u8e3s4.p1() === 1 ? _this__u8e3s4.q1(0) : null;
}
function indexOf(_this__u8e3s4, element) {
  return _this__u8e3s4.s1(element);
}
function plus_0(_this__u8e3s4, elements) {
  if (isInterface(elements, Collection())) {
    var result = ArrayList().u(_this__u8e3s4.p1() + elements.p1() | 0);
    result.r1(_this__u8e3s4);
    result.r1(elements);
    return result;
  } else {
    var result_0 = ArrayList().b1(_this__u8e3s4);
    addAll(result_0, elements);
    return result_0;
  }
}
function firstOrNull_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList())) {
    if (_this__u8e3s4.i1())
      return null;
    else
      return _this__u8e3s4.q1(0);
  } else {
    var iterator = _this__u8e3s4.m1();
    if (!iterator.n1())
      return null;
    return iterator.o1();
  }
}
function last(_this__u8e3s4) {
  if (_this__u8e3s4.i1())
    throw NoSuchElementException().o('List is empty.');
  return _this__u8e3s4.q1(get_lastIndex(_this__u8e3s4));
}
function first(_this__u8e3s4) {
  if (_this__u8e3s4.i1())
    throw NoSuchElementException().o('List is empty.');
  return _this__u8e3s4.q1(0);
}
function toList(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    var tmp;
    switch (_this__u8e3s4.p1()) {
      case 0:
        tmp = emptyList();
        break;
      case 1:
        var tmp_0;
        if (isInterface(_this__u8e3s4, KtList())) {
          tmp_0 = _this__u8e3s4.q1(0);
        } else {
          tmp_0 = _this__u8e3s4.m1().o1();
        }

        tmp = listOf(tmp_0);
        break;
      default:
        tmp = toMutableList(_this__u8e3s4);
        break;
    }
    return tmp;
  }
  return optimizeReadOnlyList(toMutableList_0(_this__u8e3s4));
}
function withIndex(_this__u8e3s4) {
  return new (IndexingIterable())(() => _this__u8e3s4.m1());
}
function toMutableList(_this__u8e3s4) {
  return ArrayList().b1(_this__u8e3s4);
}
function zip(_this__u8e3s4, other) {
  // Inline function 'kotlin.collections.zip' call
  var first = _this__u8e3s4.m1();
  var second = other.m1();
  var tmp0 = collectionSizeOrDefault(_this__u8e3s4, 10);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = collectionSizeOrDefault(other, 10);
  var tmp$ret$0 = Math.min(tmp0, b);
  var list = ArrayList().u(tmp$ret$0);
  while (first.n1() && second.n1()) {
    var tmp0_0 = first.o1();
    var t2 = second.o1();
    var tmp$ret$1 = to(tmp0_0, t2);
    list.v(tmp$ret$1);
  }
  return list;
}
function minus(_this__u8e3s4, elements) {
  var other = convertToListIfNotCollection(elements);
  if (other.i1())
    return toList(_this__u8e3s4);
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.filterNotTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (!other.t1(element)) {
      destination.v(element);
    }
  }
  return destination;
}
function drop(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().a1(toString(message));
  }
  if (n === 0)
    return toList(_this__u8e3s4);
  var list;
  if (isInterface(_this__u8e3s4, Collection())) {
    var resultSize = _this__u8e3s4.p1() - n | 0;
    if (resultSize <= 0)
      return emptyList();
    if (resultSize === 1)
      return listOf(last_0(_this__u8e3s4));
    list = ArrayList().u(resultSize);
    if (isInterface(_this__u8e3s4, KtList())) {
      if (isInterface(_this__u8e3s4, RandomAccess())) {
        var inductionVariable = n;
        var last = _this__u8e3s4.p1();
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            list.v(_this__u8e3s4.q1(index));
          }
           while (inductionVariable < last);
      } else {
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = _this__u8e3s4.u1(n);
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          list.v(item);
        }
      }
      return list;
    }
  } else {
    list = ArrayList().w();
  }
  var count = 0;
  var _iterator__ex2g4s_0 = _this__u8e3s4.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item_0 = _iterator__ex2g4s_0.o1();
    if (count >= n)
      list.v(item_0);
    else {
      count = count + 1 | 0;
    }
  }
  return optimizeReadOnlyList(list);
}
function toSet(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    var tmp;
    switch (_this__u8e3s4.p1()) {
      case 0:
        tmp = emptySet();
        break;
      case 1:
        var tmp_0;
        if (isInterface(_this__u8e3s4, KtList())) {
          tmp_0 = _this__u8e3s4.q1(0);
        } else {
          tmp_0 = _this__u8e3s4.m1().o1();
        }

        tmp = setOf(tmp_0);
        break;
      default:
        tmp = toCollection(_this__u8e3s4, LinkedHashSet().q(mapCapacity(_this__u8e3s4.p1())));
        break;
    }
    return tmp;
  }
  return optimizeReadOnlySet(toCollection(_this__u8e3s4, LinkedHashSet().v1()));
}
function plus_1(_this__u8e3s4, elements) {
  if (isInterface(_this__u8e3s4, Collection()))
    return plus_0(_this__u8e3s4, elements);
  var result = ArrayList().w();
  addAll(result, _this__u8e3s4);
  addAll(result, elements);
  return result;
}
function distinct(_this__u8e3s4) {
  return toList(toMutableSet(_this__u8e3s4));
}
function single(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.p1()) {
    case 0:
      throw NoSuchElementException().o('List is empty.');
    case 1:
      tmp = _this__u8e3s4.q1(0);
      break;
    default:
      throw IllegalArgumentException().a1('List has more than one element.');
  }
  return tmp;
}
function toHashSet(_this__u8e3s4) {
  return toCollection(_this__u8e3s4, HashSet().x1(mapCapacity(collectionSizeOrDefault(_this__u8e3s4, 12))));
}
function toBooleanArray(_this__u8e3s4) {
  var result = booleanArray(_this__u8e3s4.p1());
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    result[_unary__edvuaz] = element;
  }
  return result;
}
function intersect(_this__u8e3s4, other) {
  var set = toMutableSet(_this__u8e3s4);
  retainAll(set, other);
  return set;
}
function chunked(_this__u8e3s4, size) {
  return windowed(_this__u8e3s4, size, size, true);
}
function minus_0(_this__u8e3s4, element) {
  var result = ArrayList().u(collectionSizeOrDefault(_this__u8e3s4, 10));
  var removed = false;
  // Inline function 'kotlin.collections.filterTo' call
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element_0 = _iterator__ex2g4s.o1();
    var tmp;
    if (!removed && equals(element_0, element)) {
      removed = true;
      tmp = false;
    } else {
      tmp = true;
    }
    if (tmp) {
      result.v(element_0);
    }
  }
  return result;
}
function max(_this__u8e3s4) {
  var iterator = _this__u8e3s4.m1();
  if (!iterator.n1())
    throw NoSuchElementException().y1();
  var max = iterator.o1();
  while (iterator.n1()) {
    var e = iterator.o1();
    if (compareTo(max, e) < 0)
      max = e;
  }
  return max;
}
function maxOrNull(_this__u8e3s4) {
  var iterator = _this__u8e3s4.m1();
  if (!iterator.n1())
    return null;
  var max = iterator.o1();
  while (iterator.n1()) {
    var e = iterator.o1();
    if (compareTo(max, e) < 0)
      max = e;
  }
  return max;
}
function reversed(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = _this__u8e3s4.p1() <= 1;
  } else {
    tmp = false;
  }
  if (tmp)
    return toList(_this__u8e3s4);
  var list = toMutableList_0(_this__u8e3s4);
  reverse(list);
  return list;
}
function sortedWith(_this__u8e3s4, comparator) {
  if (isInterface(_this__u8e3s4, Collection())) {
    if (_this__u8e3s4.p1() <= 1)
      return toList(_this__u8e3s4);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = copyToArray(_this__u8e3s4);
    // Inline function 'kotlin.apply' call
    var this_0 = isArray(tmp) ? tmp : THROW_CCE();
    sortWith_0(this_0, comparator);
    return asList(this_0);
  }
  // Inline function 'kotlin.apply' call
  var this_1 = toMutableList_0(_this__u8e3s4);
  sortWith(this_1, comparator);
  return this_1;
}
function contains(_this__u8e3s4, element) {
  if (isInterface(_this__u8e3s4, Collection()))
    return _this__u8e3s4.t1(element);
  return indexOf_0(_this__u8e3s4, element) >= 0;
}
function sortDescending(_this__u8e3s4) {
  sortWith(_this__u8e3s4, reverseOrder());
}
function take(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().a1(toString(message));
  }
  if (n === 0)
    return emptyList();
  if (isInterface(_this__u8e3s4, Collection())) {
    if (n >= _this__u8e3s4.p1())
      return toList(_this__u8e3s4);
    if (n === 1)
      return listOf(first_0(_this__u8e3s4));
  }
  var count = 0;
  var list = ArrayList().u(n);
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  $l$loop: while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    list.v(item);
    count = count + 1 | 0;
    if (count === n)
      break $l$loop;
  }
  return optimizeReadOnlyList(list);
}
function singleOrNull_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return _this__u8e3s4.p1() === 1 ? _this__u8e3s4.q1(0) : null;
  else {
    var iterator = _this__u8e3s4.m1();
    if (!iterator.n1())
      return null;
    var single = iterator.o1();
    if (iterator.n1())
      return null;
    return single;
  }
}
function single_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return single(_this__u8e3s4);
  else {
    var iterator = _this__u8e3s4.m1();
    if (!iterator.n1())
      throw NoSuchElementException().o('Collection is empty.');
    var single_0 = iterator.o1();
    if (iterator.n1())
      throw IllegalArgumentException().a1('Collection has more than one element.');
    return single_0;
  }
}
function sum(_this__u8e3s4) {
  var sum = 0.0;
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    sum = sum + element;
  }
  return sum;
}
function sorted(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    if (_this__u8e3s4.p1() <= 1)
      return toList(_this__u8e3s4);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = copyToArray(_this__u8e3s4);
    // Inline function 'kotlin.apply' call
    var this_0 = isArray(tmp) ? tmp : THROW_CCE();
    sort_0(this_0);
    return asList(this_0);
  }
  // Inline function 'kotlin.apply' call
  var this_1 = toMutableList_0(_this__u8e3s4);
  sort(this_1);
  return this_1;
}
function filterNotNull(_this__u8e3s4) {
  return filterNotNullTo(_this__u8e3s4, ArrayList().w());
}
function average(_this__u8e3s4) {
  var sum = 0.0;
  var count = 0;
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    sum = sum + element;
    count = count + 1 | 0;
    checkCountOverflow(count);
  }
  return count === 0 ? NaN : sum / count;
}
function elementAtOrNull(_this__u8e3s4, index) {
  if (isInterface(_this__u8e3s4, KtList()))
    return getOrNull(_this__u8e3s4, index);
  if (index < 0)
    return null;
  var iterator = _this__u8e3s4.m1();
  var count = 0;
  while (iterator.n1()) {
    var element = iterator.o1();
    var _unary__edvuaz = count;
    count = _unary__edvuaz + 1 | 0;
    if (index === _unary__edvuaz)
      return element;
  }
  return null;
}
function indexOf_0(_this__u8e3s4, element) {
  if (isInterface(_this__u8e3s4, KtList()))
    return _this__u8e3s4.s1(element);
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    checkIndexOverflow(index);
    if (equals(element, item))
      return index;
    index = index + 1 | 0;
  }
  return -1;
}
function toMutableList_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection()))
    return toMutableList(_this__u8e3s4);
  return toCollection(_this__u8e3s4, ArrayList().w());
}
function last_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return last(_this__u8e3s4);
  else {
    var iterator = _this__u8e3s4.m1();
    if (!iterator.n1())
      throw NoSuchElementException().o('Collection is empty.');
    var last_0 = iterator.o1();
    while (iterator.n1())
      last_0 = iterator.o1();
    return last_0;
  }
}
function toCollection(_this__u8e3s4, destination) {
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    destination.v(item);
  }
  return destination;
}
function toMutableSet(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = LinkedHashSet().z1(_this__u8e3s4);
  } else {
    tmp = toCollection(_this__u8e3s4, LinkedHashSet().v1());
  }
  return tmp;
}
function windowed(_this__u8e3s4, size, step, partialWindows) {
  step = step === VOID ? 1 : step;
  partialWindows = partialWindows === VOID ? false : partialWindows;
  checkWindowSizeStep(size, step);
  var tmp;
  if (isInterface(_this__u8e3s4, RandomAccess())) {
    tmp = isInterface(_this__u8e3s4, KtList());
  } else {
    tmp = false;
  }
  if (tmp) {
    var thisSize = _this__u8e3s4.p1();
    var resultCapacity = (thisSize / step | 0) + ((thisSize % step | 0) === 0 ? 0 : 1) | 0;
    var result = ArrayList().u(resultCapacity);
    var index = 0;
    $l$loop: while (0 <= index ? index < thisSize : false) {
      var windowSize = coerceAtMost(size, thisSize - index | 0);
      if (windowSize < size && !partialWindows)
        break $l$loop;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var list = ArrayList().u(windowSize);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < windowSize)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0 = _this__u8e3s4.q1(index_0 + index | 0);
          list.v(tmp$ret$0);
        }
         while (inductionVariable < windowSize);
      result.v(list);
      index = index + step | 0;
    }
    return result;
  }
  var result_0 = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = windowedIterator(_this__u8e3s4.m1(), size, step, partialWindows, false);
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    result_0.v(element);
  }
  return result_0;
}
function first_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return first(_this__u8e3s4);
  else {
    var iterator = _this__u8e3s4.m1();
    if (!iterator.n1())
      throw NoSuchElementException().o('Collection is empty.');
    return iterator.o1();
  }
}
function filterNotNullTo(_this__u8e3s4, destination) {
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (!(element == null)) {
      destination.v(element);
    }
  }
  return destination;
}
function shuffle(_this__u8e3s4, random) {
  var inductionVariable = get_lastIndex(_this__u8e3s4);
  if (1 <= inductionVariable)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      var j = random.a2(i + 1 | 0);
      _this__u8e3s4.b2(j, _this__u8e3s4.b2(i, _this__u8e3s4.q1(j)));
    }
     while (1 <= inductionVariable);
}
function minOrNull(_this__u8e3s4) {
  var iterator = _this__u8e3s4.m1();
  if (!iterator.n1())
    return null;
  var min = iterator.o1();
  while (iterator.n1()) {
    var e = iterator.o1();
    if (compareTo(min, e) > 0)
      min = e;
  }
  return min;
}
function takeLast(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().a1(toString(message));
  }
  if (n === 0)
    return emptyList();
  var size = _this__u8e3s4.p1();
  if (n >= size)
    return toList(_this__u8e3s4);
  if (n === 1)
    return listOf(last(_this__u8e3s4));
  var list = ArrayList().u(n);
  if (isInterface(_this__u8e3s4, RandomAccess())) {
    var inductionVariable = size - n | 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.v(_this__u8e3s4.q1(index));
      }
       while (inductionVariable < size);
  } else {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = _this__u8e3s4.u1(size - n | 0);
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      list.v(item);
    }
  }
  return list;
}
function plus_2(_this__u8e3s4, elements) {
  var result = ArrayList().u(_this__u8e3s4.p1() + 10 | 0);
  result.r1(_this__u8e3s4);
  addAll_0(result, elements);
  return result;
}
function union(_this__u8e3s4, other) {
  var set = toMutableSet(_this__u8e3s4);
  addAll(set, other);
  return set;
}
var asSequence$$inlined$Sequence$1Class;
function asSequence$$inlined$Sequence$1() {
  if (asSequence$$inlined$Sequence$1Class === VOID) {
    class $ {
      constructor($this_asSequence) {
        this.c2_1 = $this_asSequence;
      }
      m1() {
        return this.c2_1.m1();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Sequence()]);
    asSequence$$inlined$Sequence$1Class = $;
  }
  return asSequence$$inlined$Sequence$1Class;
}
//region block: exports
export {
  asSequence as asSequence2phdjljfh9jhx,
  average as average1u332mxgzjdwv,
  chunked as chunked1umgsyuj0x9u1,
  contains as contains2gm06f5aa19ov,
  distinct as distinct10qe1scfdvu5k,
  dropLast as dropLast1vpiyky649o34,
  drop as drop3na99dw9feawf,
  elementAtOrNull as elementAtOrNullh9s62cephf63,
  filterNotNull as filterNotNull3qfgcwmxhwfxe,
  firstOrNull as firstOrNull1982767dljvdy,
  firstOrNull_0 as firstOrNullf6vlo6vdgu1e,
  first as first58ocm7j58k3q,
  first_0 as first28gmhyvs4kf06,
  getOrNull as getOrNull1go7ef9ldk0df,
  indexOf as indexOfa2zokh3tu4p6,
  indexOf_0 as indexOf382xk9sq5x0r4,
  intersect as intersect7qttw6wlmz1n,
  joinToString as joinToString1cxrrlmo0chqs,
  joinTo as joinTo3lkanfaxbzac2,
  lastOrNull as lastOrNull1aq5oz189qoe1,
  last as last1vo29oleiqj36,
  maxOrNull as maxOrNull2e5ok5wkly1cp,
  max as max2o8z1isrnjymo,
  minOrNull as minOrNull1g8m0136x75mg,
  minus_0 as minus1djrl64vbav3y,
  minus as minus2znw4oicpx34e,
  plus_2 as plus3pcnntex3h8m,
  plus_1 as plus39kp8wyage607,
  plus_0 as plus310ted5e4i90h,
  plus as plus20p0vtfmu0596,
  reversed as reversed22y3au42jl32b,
  shuffle as shuffle28202iiliqd4i,
  singleOrNull as singleOrNullrknfaxokm1sl,
  singleOrNull_0 as singleOrNull21olsob387p54,
  single as singleo93pzdgfc557,
  single_0 as single3ds7xj9roxi5z,
  sortDescending as sortDescending17f1fftsbt2oe,
  sortedWith as sortedWith2csnbbb21k0lg,
  sorted as sorted354mfsiv4s7x5,
  sum as sum3e7yagmfz1l7l,
  takeLast as takeLasttm5u17ojwaaq,
  take as take3onnpy6q7ctcz,
  toBooleanArray as toBooleanArray2u3qw7fjwsmuh,
  toHashSet as toHashSet1qrcsl3g8ugc8,
  toList as toList3jhuyej2anx2q,
  toMutableList as toMutableList20rdgwi7d3cwi,
  toMutableList_0 as toMutableListoiy7juhbnlr7,
  toMutableSet as toMutableSetjdpdbr9jsqq8,
  toSet as toSet2orjxp16sotqu,
  union as union28sojvmrkgw6y,
  withIndex as withIndex37cl61h9v5txo,
  zip as zipfdxxupzuj2p9,
};
//endregion

//# sourceMappingURL=_Collections.mjs.map
